module.exports = __webpack_public_path__ + "img/logo-min-white.1e070323.svg";